import {
  Box,
  Card,
  CardProps,
  ChevronDownIcon,
  ChevronUpIcon,
  Flex,
  FlexProps
} from '@blockanalitica/ui';
import { ReactNode, useState } from 'react';
import styled, { css } from 'styled-components';

interface ExpandableKpiCardProps {
  text: ReactNode;
  kpiCard: ReactNode;
  children: ReactNode;
  defaultShowChart?: boolean;
  justChart?: boolean;
  expandText?: string;
  hoverBorderColor?: string;
}

const Title = styled(Flex)<FlexProps>`
  font-weight: 600;
  font-size: ${(props) => props.theme.sizes[-1]};
  color: ${(props) => props.theme.colors.muted};
`;
const ShowBtn = styled(Flex)<FlexProps>`
  cursor: pointer;
  text-decoration: underline dotted;

  ${(props) => css`
    color: ${props.theme.colors.muted};
    font-size: ${props.theme.sizes[-1]};
  `}

  &:hover {
    text-decoration: unset;
    color: ${(props) => props.theme.colors.linkHover};
  }
`;
interface ActiveCardProps extends CardProps {
  $hoverBorderColor: string;
  $active?: boolean;
}
const ActiveCard = styled(Card)<ActiveCardProps>`
  ${({ $active, theme, $hoverBorderColor }) =>
    !$active &&
    `
      cursor: pointer;
      outline: solid 1px ${theme.colors.onSurface};
      outline-offset: -1px;

      &:hover {
        outline-color: ${$hoverBorderColor.startsWith('#') ? $hoverBorderColor : theme.colors[$hoverBorderColor]};
      }
    `}
`;

export default function ExpandableKpiCard({
  text,
  kpiCard,
  defaultShowChart = false,
  expandText = 'Historic Chart',
  justChart = true,
  hoverBorderColor = 'linkHover',
  children
}: ExpandableKpiCardProps) {
  const [showChart, setShowChart] = useState(defaultShowChart);

  return (
    <ActiveCard
      $hoverBorderColor={hoverBorderColor}
      $active={showChart}
      flexDirection="column"
      gap="xs"
      onClick={showChart ? undefined : () => setShowChart(!showChart)}>
      <Flex
        flexDirection={['column', 'row']}
        gap="xs"
        justifyContent="space-between">
        <Flex flexDirection="column" gap="xs">
          <Title>{text}</Title>
          {kpiCard}
        </Flex>
        <Flex>
          <ShowBtn
            alignItems="center"
            gap="3xs"
            onClick={!showChart ? undefined : () => setShowChart(!showChart)}>
            {showChart ? (
              <ChevronUpIcon size="-2" />
            ) : (
              <ChevronDownIcon size="-2" />
            )}
            <Box>
              {showChart ? 'Hide' : 'Show'} {expandText}
            </Box>
          </ShowBtn>
        </Flex>
      </Flex>
      {showChart ? (
        justChart ? (
          <Card backgroundColor="foreground">{children}</Card>
        ) : (
          <>{children}</>
        )
      ) : null}
    </ActiveCard>
  );
}
